"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitColorPickerColorTokens = splitColorPickerColorTokens;
/**
 * Split a `<Color-Picker>` `colors` attribute into CSS color tokens.
 * Commas inside parentheses (e.g. rgb(), rgba(), hsl()) do not start a new token.
 *
 * Kept in a standalone module so browsers and the backend can share it without
 * importing {@link RichTextParser} (large, and CJS↔ESM interop can leave it undefined).
 *
 * Frontend duplicate: `frontend/src/utils/splitColorPickerColorTokens.ts` — keep in sync.
 */
function splitColorPickerColorTokens(colors) {
    const parts = [];
    let buf = '';
    let depth = 0;
    for (let i = 0; i < colors.length; i++) {
        const c = colors[i];
        if (c === '(') {
            depth++;
        }
        else if (c === ')') {
            depth = Math.max(0, depth - 1);
        }
        if (c === ',' && depth === 0) {
            const t = buf.trim();
            if (t.length > 0) {
                parts.push(t);
            }
            buf = '';
        }
        else {
            buf += c;
        }
    }
    const t = buf.trim();
    if (t.length > 0) {
        parts.push(t);
    }
    return parts;
}
//# sourceMappingURL=splitColorPickerColorTokens.js.map